import { getUrl } from "utils/urlHelper";

export const BASE_SHARED_API_URL = process.env.REACT_APP_SHARED_API_URL
  ? getUrl(String(process.env.REACT_APP_SHARED_API_URL))
  : undefined;

export const BASE_URL = process.env.REACT_APP_URL
  ? getUrl(String(process.env.REACT_APP_URL))
  : undefined;
